import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

function CustomSelectedItem(props) {
  const {
    item, value, selectedOption, onChange
  } = props;

  const isChecked = selectedOption === item.id;

  return (
    <Container alignItems="center">
      <label
        className={`customRadio ${isChecked ? 'checked' : ''}`}
        htmlFor={`item_${item.id}`}
      >
        <input
          type="radio"
          name="principal"
          id={`item_${item.id}`}
          value={item.id}
          checked={isChecked}
          onChange={onChange}
        />
        {value}
      </label>
    </Container>
  );
}

CustomSelectedItem.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  selectedOption: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default CustomSelectedItem;
